import { render, staticRenderFns } from "./WoTermCategoryForm.vue?vue&type=template&id=6d91a3a2&"
import script from "./WoTermCategoryForm.vue?vue&type=script&lang=js&"
export * from "./WoTermCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports